import React, { useContext, useEffect, useState } from 'react';
import { Card, Form, Col, Row, Badge } from 'react-bootstrap';
import '../App.css';
import { ChildAmountContext } from '../UserContext';
import { ContentTitle } from './ContentTitle';
import {
  tokenIsValid,
  getToken,
  getUserPrimaryEmail,
  changeDateFormatToYYYYMMDD,
  changeDateFormatToYearMonthDay,
  checkIsReschedule,
  getNationalityShortName,
  sessionStorageGetItem,
} from './Function';
import './PassengerDetails.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function PassengerDetails({
  parentPassengerDetailCallback,
  // depart,
  // destination,
  depart_date,
  return_date,
  passenger_count,
  userData,
  reschedulePassengerDetails,
}) {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { childAmount, setChildAmount } = useContext(ChildAmountContext);
  const [adultAmount, setAdultAmount] = useState(passenger_count);
  const [ticketType, setTicketType] = useState({});
  const [identityType, setIdentityType] = useState({});
  const [dob, setDob] = useState({});
  const [ppexp, setPPexp] = useState({});
  const checkReschedule = checkIsReschedule();
  const [FnFdata, setFnFData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tmpIndex, setTmpIndex] = useState(null);
  const [tmpIC, setTmpIC] = useState('');
  const [tmpPP, setTmpPP] = useState('');
  const [tmpPPExp, setTmpPPExp] = useState('');
  const [passengerIndex, setPassengerIndex] = useState(0);
  const departData = JSON.parse(sessionStorageGetItem('Origin_data'));
  const destinationData = JSON.parse(sessionStorageGetItem('Destination_data'));
  console.log(departData);
  console.log(destinationData);

  useEffect(() => {
    // console.log(tmpIndex)
    // console.log(document.getElementById(`passport_${tmpIndex}`))
    if (tmpIndex !== null) {
      if (document.getElementById(`ic_${tmpIndex}`) != null) {
        document.getElementById(`ic_${tmpIndex}`).value = tmpIC;
      } else if (document.getElementById(`passport_${tmpIndex}`) != null) {
        document.getElementById(`passport_${tmpIndex}`).value = tmpPP;
        setPassportExpiryField(tmpIndex, new Date(tmpPPExp));
        // document.getElementById(`passport_expiry_date_${tmpIndex}`).value = tmpPPExp
      }
      setTmpIC('');
      setTmpPP('');
      setTmpPPExp('');
      setTmpIndex(null);
    }
  }, [identityType]);

  // console.log(FnFdata)
  // console.log(tmpIndex)
  // console.log(document.getElementById(`passport_${tmpIndex}`))
  const updateSelectedDropdownClassList = (value, id) => {
    const selectedID = document.getElementById(id);
    if (value === '') {
      if (!selectedID.classList.contains('first-data')) {
        selectedID.classList.add('first-data');
      }
    } else {
      if (selectedID.classList.contains('first-data')) {
        selectedID.classList.remove('first-data');
      }
    }
  };

  const token = getToken();
  useEffect(() => {
    const getFnFData = async () => {
      try {
        const FnF_response = await fetch(
          `${SERVER_URL}/user/list/family/${getUserPrimaryEmail()}`,
          {
            headers: {
              Authorization: token,
            },
          },
        );
        if (!FnF_response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${FnF_response.status}`,
          );
        }
        let FnF_Data = await FnF_response.json();
        setFnFData(FnF_Data);
        // console.log(FnF_Data)
      } catch (err) {
        setFnFData(null);
      } finally {
        setLoading(false);
      }
    };
    tokenIsValid();
    if (getUserPrimaryEmail() != null) {
      getFnFData();
    }
  }, [getToken()]);

  const setDobField = (field, value) => {
    setDob({
      ...dob,
      [field]: value,
    });
  };

  const setPassportExpiryField = (field, value) => {
    setPPexp({
      ...ppexp,
      [field]: value,
    });
  };
  // console.log(reschedulePassengerDetails)
  useEffect(() => {
    if (checkReschedule == true) {
      let dobArr = [];
      let IdTypeObj = {};
      let PPExpObj = {};

      reschedulePassengerDetails.forEach((element, index) => {
        dobArr.push(new Date(element.PassengerDateOfBirth.split('T')[0]));
        // console.log(element.PassengerPassportExpiryDate)
        if (
          element.PassengerPassportExpiryDate != '' &&
          element.PassengerPassportExpiryDate != null
        ) {
          // setIdType(index,true)
          // setPassportExpiryField(index, new Date(element.PassengerPassportExpiryDate))
          IdTypeObj[index] = true;
          PPExpObj[index] = new Date(element.PassengerPassportExpiryDate);
          // console.log(identityType)
        }
      });
      // console.log(IdTypeObj)
      // console.log(PPExpObj)
      setPPexp(PPExpObj);
      setIdentityType(IdTypeObj);
      setDob(dobArr);
    } else {
      if (userData != null) {
        if (userData.dob != null && userData.dob != '') {
          setDobField('0', new Date(userData.dob));
        }
        // console.log(userData)
        if (userData.passport != '' && userData.passportexpiry != '') {
          setIdType(0, true);
          setPassportExpiryField(0, new Date(userData.passportexpiry));
        } else {
          setIdType(0, false);
        }
      }
    }
  }, []);
  // checkReschedule==true?reschedulePassengerDetails[i].PassengerDateOfBirth.split("T")[0]:(i==0 && userData!= null) ? userData.dob != '' ? changeDateFormatToYearMonthDay(userData.dob) : "" : ""
  const [form, setForm] = useState({});
  // console.log(reschedulePassengerDetails)
  function checkChildAmount() {
    let childCount = 0;
    var arr = Object.values(ticketType);
    arr.forEach((element) => {
      if (element === 'C') {
        childCount++;
      }
    });
    return childCount;
  }
  // console.log(userData)

  useEffect(() => {
    const child = checkChildAmount();
    setChildAmount(child);
  }, [ticketType]);

  const setField = (field, value) => {
    setTicketType({
      ...ticketType,
      [field]: value,
    });
  };

  const setIdType = (field, value) => {
    // console.log("Field=>" + field)
    // console.log("Value=>" + value)
    setIdentityType({
      ...identityType,
      [field]: value,
    });
  };
  // console.log(identityType);

  const handleChangeIdentityType = (event, i) => {
    if (event.target.value === 'IC') {
      setIdType(i, false);
      parentPassengerDetailCallback(event, '', 'passport', i);
      parentPassengerDetailCallback(event, '', 'passport_expiry_date', i);
    } else {
      setIdType(i, true);
      parentPassengerDetailCallback(event, '', 'ic', i);
    }
  };
  const updateChildAmount = (event, i) => {
    setField(i, event.target.value);
    // console.log(i);
  };
  // console.log(form);
  // console.log(ticketType.ticket0)
  // console.log("Child: " +childAmount)
  // console.log("Adult: " +adultAmount)

  let selected_depart_seat = sessionStorageGetItem('selectedDepartSeat');
  let selected_return_seat = sessionStorageGetItem('selectedReturnSeat');
  let array_depart_seat = eval(selected_depart_seat); //.split(",");
  let array_return_seat = eval(selected_return_seat); //.split(",");

  // console.log('---------------------');
  // console.dir((array_depart_seat));
  // console.log('---------------------');

  function populatePassenger(data, index) {
    setPassengerIndex(index);
    const i = index;
    // Reset/Clear logic if needed, or just overwrite.

    // 1. Common Fields
    // Name
    parentPassengerDetailCallback(
      { target: { value: data.full_name } },
      data.full_name,
      'guest_name',
      i,
    );
    const nameInput = document.getElementById(`guest_name_${i}`);
    if (nameInput) nameInput.value = data.full_name;

    // Nationality
    if (data.nationality) {
      parentPassengerDetailCallback(
        { target: { value: data.nationality } },
        data.nationality,
        'nationality',
        i,
      );
      const natInput = document.getElementById(`nationality_${i}`);
      if (natInput) {
        natInput.value = data.nationality;
        updateSelectedDropdownClassList(data.nationality, `nationality_${i}`);
      }
    }

    const ticketType =
      departData.placeuniqueshortname.includes('singapore') ||
      destinationData.placeuniqueshortname.includes('singapore')
        ? 'A'
        : data.ticket_type;

    // Ticket Type
    if (data.ticket_type) {
      parentPassengerDetailCallback(
        { target: { value: ticketType } },
        ticketType,
        'ticket_type',
        i,
      );
      const typeInput = document.getElementById(`ticket_type_${i}`);
      if (typeInput) {
        typeInput.value = ticketType;
        updateSelectedDropdownClassList(ticketType, `ticket_type_${i}`);
      }
    }

    // Gender (if available) - Assuming `gender` key might exist in FnFdata based on typical user objects
    if (data.gender) {
      parentPassengerDetailCallback(
        { target: { value: data.gender } },
        data.gender,
        'gender',
        i,
      );
      const genderInput = document.getElementById(`gender_${i}`);
      if (genderInput) {
        genderInput.value = data.gender;
        updateSelectedDropdownClassList(data.gender, `gender_${i}`);
      }
    }

    // DOB (if available) - Assuming `dob` key
    if (data.dob) {
      const dateObj = new Date(data.dob);
      if (!isNaN(dateObj)) {
        parentPassengerDetailCallback(
          dateObj,
          changeDateFormatToYYYYMMDD(dateObj),
          'dob',
          i,
        );
        setDobField(i, dateObj);
      }
    }

    // 2. Identity Logic (IC vs Passport)
    const idSelect = document.getElementById(`identity_type_${i}`);

    if (data.ic && data.ic !== '') {
      // Case: IC
      setTmpIC(data.ic);
      setTmpIndex(i); // Triggers useEffect to update DOM

      setIdType(i, false); // false = IC (based on usage in handleChangeIdentityType line 204: value 'IC' -> setIdType(i, false))

      // Update Context/State
      if (idSelect) idSelect.value = 'IC';
      parentPassengerDetailCallback({ target: { value: 'IC' } }, 'IC', 'ic', i); // trigger generic update if needed? Actually handleChangeIdentityType takes care of switching but we are doing it manually.

      // We need to ensure the parent callback knows we switched to IC types
      // Based on `handleChangeIdentityType`:
      // parentPassengerDetailCallback(event, '', 'passport', i);
      // parentPassengerDetailCallback(event, '', 'passport_expiry_date', i);
      // parentPassengerDetailCallback(event, '', 'ic', i); <--- wait, handleChange passes '' for IC? No, line 209: parentPassengerDetailCallback(event, '', 'ic', i);
      // It seems handleChange just clears the *other* values?

      // Let's replicate `autofill` logic for IC:
      // parentPassengerDetailCallback(event, '', 'passport', i);
      // parentPassengerDetailCallback(event, '', 'passport_expiry_date', i);
      // parentPassengerDetailCallback(event, FnFdata[j].ic, 'ic', i);

      parentPassengerDetailCallback(
        { target: { value: '' } },
        '',
        'passport',
        i,
      );
      parentPassengerDetailCallback(
        { target: { value: '' } },
        '',
        'passport_expiry_date',
        i,
      );
      parentPassengerDetailCallback(
        { target: { value: data.ic } },
        data.ic,
        'ic',
        i,
      );
    } else if (data.passport && data.passport !== '') {
      // Case: Passport
      setTmpPP(data.passport);
      setTmpPPExp(data.passport_expiry);
      setTmpIndex(i);

      setIdType(i, true); // true = Passport

      if (idSelect) idSelect.value = 'PP';

      // Replicate `autofill` logic for PP:
      // parentPassengerDetailCallback(event, '', 'ic', i);
      // parentPassengerDetailCallback(event, FnFdata[j].passport, 'passport', i);
      // parentPassengerDetailCallback(event, FnFdata[j].passport_expiry, 'passport_expiry_date', i);

      parentPassengerDetailCallback({ target: { value: '' } }, '', 'ic', i);
      parentPassengerDetailCallback(
        { target: { value: data.passport } },
        data.passport,
        'passport',
        i,
      );
      parentPassengerDetailCallback(
        { target: { value: data.passport_expiry } },
        data.passport_expiry,
        'passport_expiry_date',
        i,
      );

      // Set PP Expiry Date Object for DatePicker
      if (data.passport_expiry) {
        setPassportExpiryField(i, new Date(data.passport_expiry));
      }
    }
  }

  if (array_depart_seat.length == 0) {
    window.location.href = '/';
  }
  return (
    <>
      <div className='passenger_details pt-3'>
        <ContentTitle
          title='Fill Passenger Details'
          description="Who's travelling?"
        />
        <div className='passenger_form'>
          <Form>
            <div className='mb-3'>
              <div className='form-info-banner'>
                <div className='form-info-icon' aria-hidden='true'>
                  ⚠️
                </div>

                <div className='form-info-content'>
                  <div className='form-info-title'>
                    <span className='form-info-asterisk'>*</span>All fields are
                    mandatory
                  </div>

                  <ul className='form-info-list'>
                    <li>
                      Ensure your <strong>Name</strong>,{' '}
                      <strong>IC/Passport</strong>, and{' '}
                      <strong>Date of Birth</strong> are accurate for ticket
                      issuance and boarding.
                    </li>
                    <li>
                      For rides with insurance, all passenger details must be
                      accurate to ensure coverage.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* datalist removed: Quick Select used instead */}

            <section className='passenger-list'>
              {Array.from({ length: passenger_count }, (_, i) => {
                const title =
                  i === 0
                    ? 'Primary Passenger Information'
                    : `Passenger Information ${i + 1}`;

                const depart = array_depart_seat?.[i]?.DisplayCode ?? '';
                const ret = array_return_seat?.[i]?.DisplayCode ?? '';
                const seatText = ret
                  ? `Depart ${depart}  •  Return ${ret}`
                  : `Depart ${depart}`;

                return (
                  <Card key={i} className='passenger-card'>
                    <Card.Body className='passenger-body'>
                      {/* Header */}
                      <div className='passenger-header'>
                        <div className='passenger-header-left'>
                          <div className='passenger-title'>{title}</div>
                          <div className='passenger-subtitle'>{seatText}</div>
                        </div>

                        <div className='passenger-header-right'>
                          <Badge
                            bg='light'
                            text='dark'
                            className='passenger-badge'
                          >
                            Passenger #{i + 1}
                          </Badge>
                        </div>
                      </div>

                      <div className='passenger-divider' />

                      <Row className='mb-4'>
                        <Col md={12}>
                          <div className='quick-select-container'>
                            <span className='quick-select-label'>
                              Quick Select Saved Passengers
                            </span>
                            <div className='quick-select-buttons'>
                              {FnFdata && FnFdata.length > 0 ? (
                                FnFdata.map((person, idx) => (
                                  <span
                                    key={idx}
                                    className='quick-select-badge'
                                    onClick={() => populatePassenger(person, i)}
                                    role='button'
                                    tabIndex={0}
                                  >
                                    <span
                                      className='material-symbols-outlined'
                                      style={{ fontSize: '14px' }}
                                    >
                                      person
                                    </span>
                                    {person.full_name || 'Unnamed'}
                                  </span>
                                ))
                              ) : (
                                <span
                                  className='text-muted'
                                  style={{ fontSize: '0.8rem' }}
                                >
                                  No saved passengers found.
                                </span>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* Main fields */}
                      <Row className='g-2'>
                        <Col md={6}>
                          <Form.Label className='label'>TICKET TYPE</Form.Label>
                          <Form.Select
                            disabled={!!checkReschedule}
                            id={`ticket_type_${i}`}
                            className='field'
                            defaultValue={
                              checkReschedule
                                ? reschedulePassengerDetails[i].PassengerType
                                : 'A'
                            }
                            onChange={(event) => {
                              parentPassengerDetailCallback(
                                event,
                                event.target.value,
                                'ticket_type',
                                i,
                              );
                              updateChildAmount(event, i);
                              updateSelectedDropdownClassList(
                                event.target.value,
                                `ticket_type_${i}`,
                              );
                            }}
                          >
                            <option value=''>Select Ticket Type</option>
                            <option value='A'>Adult</option>
                            {!(
                              departData.placeuniqueshortname.includes(
                                'singapore',
                              ) ||
                              destinationData.placeuniqueshortname.includes(
                                'singapore',
                              )
                            ) && <option value='C'>Child / OKU</option>}
                          </Form.Select>
                        </Col>
                        <Col md={6}>
                          <Form.Label className='label'>
                            FULL NAME (AS PER ID/PASSPORT)
                          </Form.Label>
                          <Form.Control
                            disabled={!!checkReschedule}
                            autoComplete='off'
                            id={`guest_name_${i}`}
                            // list="fnf" Removed datalist
                            className='field'
                            type='text'
                            placeholder='e.g. JOHN'
                            onChange={(event) =>
                              parentPassengerDetailCallback(
                                event,
                                event.target.value,
                                'guest_name',
                                i,
                              )
                            }
                            defaultValue={
                              checkReschedule
                                ? reschedulePassengerDetails[i].PassengerName
                                : i === 0 && userData != null
                                  ? userData.fullname
                                  : ''
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <Form.Label className='label'>GENDER</Form.Label>
                          <Form.Select
                            disabled={!!checkReschedule}
                            id={`gender_${i}`}
                            className='field'
                            defaultValue={
                              checkReschedule
                                ? reschedulePassengerDetails[i].PasseengerGender
                                : i === 0 && userData !== null
                                  ? userData.gender
                                  : ''
                            }
                            onChange={(event) => {
                              parentPassengerDetailCallback(
                                event,
                                event.target.value,
                                'gender',
                                i,
                              );
                              updateSelectedDropdownClassList(
                                event.target.value,
                                `gender_${i}`,
                              );
                            }}
                          >
                            <option value=''>Gender</option>
                            <option value='M'>Male</option>
                            <option value='F'>Female</option>
                          </Form.Select>
                        </Col>

                        <Col md={6}>
                          <Form.Label className='label'>
                            DATE OF BIRTH (DD/MM/YYYY)
                          </Form.Label>
                          <DatePicker
                            withPortal
                            portalId='datepicker-portal'
                            popperPlacement='bottom-start'
                            onChange={(date) => {
                              parentPassengerDetailCallback(
                                date,
                                changeDateFormatToYYYYMMDD(date),
                                'dob',
                                i,
                              );
                              setDobField(i, date);
                            }}
                            selected={dob[i]}
                            disabled={!!checkReschedule}
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode='select'
                            placeholderText='DD/MM/YYYY'
                            dateFormat='dd/MM/yyyy'
                            className='field datepicker'
                          />
                          {/* <div className="helper">Format: DD/MM/YYYY</div> */}
                        </Col>

                        <Col md={6}>
                          <Form.Label className='label'>NATIONALITY</Form.Label>
                          <Form.Select
                            disabled={!!checkReschedule}
                            id={`nationality_${i}`}
                            className='field'
                            defaultValue={
                              checkReschedule
                                ? getNationalityShortName(
                                    reschedulePassengerDetails[i]
                                      .PasseengerNationality,
                                  )
                                : i === 0 && userData !== null
                                  ? userData.nationality
                                  : ''
                            }
                            onChange={(event) => {
                              parentPassengerDetailCallback(
                                event,
                                event.target.value,
                                'nationality',
                                i,
                              );
                              updateSelectedDropdownClassList(
                                event.target.value,
                                `nationality_${i}`,
                              );
                            }}
                          >
                            <option value=''>Nationality</option>
                            <option value='MY'>Malaysia</option>
                            <option value='SG'>Singapore</option>
                            <option value='AF'>Afghanistan</option>
                            <option value='AL'>Albania</option>
                            <option value='DZ'>Algeria</option>
                            <option value='AD'>Andorra</option>
                            <option value='AO'>Angola</option>
                            <option value='AI'>Anguilla</option>
                            <option value='AG'>Antigua and Barbuda</option>
                            <option value='AR'>Argentina</option>
                            <option value='AM'>Armenia</option>
                            <option value='AW'>Aruba</option>
                            <option value='AU'>Australia</option>
                            <option value='AT'>Austria</option>
                            <option value='AZ'>Azerbaijan</option>
                            <option value='BS'>Bahamas</option>
                            <option value='BH'>Bahrain</option>
                            <option value='BD'>Bangladesh</option>
                            <option value='BB'>Barbados</option>
                            <option value='BY'>Belarus</option>
                            <option value='BE'>Belgium</option>
                            <option value='BZ'>Belize</option>
                            <option value='BJ'>Benin</option>
                            <option value='BM'>Bermuda</option>
                            <option value='BT'>Bhutan</option>
                            <option value='BO'>Bolivia</option>
                            <option value='BA'>Bosnia and Herzegovina</option>
                            <option value='BW'>Botswana</option>
                            <option value='BR'>Brazil</option>
                            <option value='VG'>British Virgin Islands</option>
                            <option value='BN'>Brunei</option>
                            <option value='BG'>Bulgaria</option>
                            <option value='BF'>Burkina Faso</option>
                            <option value='BI'>Burundi</option>
                            <option value='KH'>Cambodia</option>
                            <option value='CM'>Cameroon</option>
                            <option value='CA'>Canada</option>
                            <option value='CV'>Cape Verde</option>
                            <option value='KY'>Cayman Islands</option>
                            <option value='CF'>Central African Republic</option>
                            <option value='TD'>Chad</option>
                            <option value='CL'>Chile</option>
                            <option value='CN'>China</option>
                            <option value='CO'>Colombia</option>
                            <option value='KM'>Comoros</option>
                            <option value='CD'>
                              Congo, Democratic Republic of the
                            </option>
                            <option value='CG'>Congo, Republic of</option>
                            <option value='CR'>Costa Rica</option>
                            <option value='CI'>
                              Cote D'Ivoire (Ivory Coast)
                            </option>
                            <option value='HR'>Croatia</option>
                            <option value='CU'>Cuba</option>
                            <option value='CY'>Cyprus</option>
                            <option value='CZ'>Czech Republic</option>
                            <option value='DK'>Denmark</option>
                            <option value='DJ'>Djibouti</option>
                            <option value='DM'>Dominica</option>
                            <option value='DO'>Dominican Republic</option>
                            <option value='EC'>Ecuador</option>
                            <option value='EG'>Egypt</option>
                            <option value='SV'>El Salvador</option>
                            <option value='GQ'>Equatorial Guinea</option>
                            <option value='ER'>Eritrea</option>
                            <option value='EE'>Estonia</option>
                            <option value='ET'>Ethiopia</option>
                            <option value='FK'>Falkland Islands</option>
                            <option value='FJ'>Fiji</option>
                            <option value='FI'>Finland</option>
                            <option value='FR'>France</option>
                            <option value='GF'>French Guiana</option>
                            <option value='PF'>French Polynesia</option>
                            <option value='GA'>Gabon</option>
                            <option value='GM'>Gambia</option>
                            <option value='GE'>Georgia</option>
                            <option value='DE'>Germany</option>
                            <option value='GH'>Ghana</option>
                            <option value='GI'>Gibraltar</option>
                            <option value='GR'>Greece</option>
                            <option value='GD'>Grenada</option>
                            <option value='GP'>Guadeloupe</option>
                            <option value='GT'>Guatemala</option>
                            <option value='GN'>Guinea</option>
                            <option value='GW'>Guinea-Bissau</option>
                            <option value='GY'>Guyana</option>
                            <option value='HT'>Haiti</option>
                            <option value='HN'>Honduras</option>
                            <option value='HK'>Hong Kong (China)</option>
                            <option value='HU'>Hungary</option>
                            <option value='IS'>Iceland</option>
                            <option value='IN'>India</option>
                            <option value='ID'>Indonesia</option>
                            <option value='IR'>Iran</option>
                            <option value='IQ'>Iraq</option>
                            <option value='IE'>Ireland</option>
                            <option value='IL'>Israel</option>
                            <option value='IT'>Italy</option>
                            <option value='JM'>Jamaica</option>
                            <option value='JP'>Japan</option>
                            <option value='JO'>Jordan</option>
                            <option value='KZ'>Kazakhstan</option>
                            <option value='KE'>Kenya</option>
                            <option value='KP'>Korea (North)</option>
                            <option value='KR'>Korea (South)</option>
                            <option value='KW'>Kuwait</option>
                            <option value='KG'>Kyrgyzstan</option>
                            <option value='LA'>Laos</option>
                            <option value='LV'>Latvia</option>
                            <option value='LB'>Lebanon</option>
                            <option value='LS'>Lesotho</option>
                            <option value='LR'>Liberia</option>
                            <option value='LY'>Libyan Arab Jamahiriya</option>
                            <option value='LI'>Liechtenstein</option>
                            <option value='LT'>Lithuania</option>
                            <option value='LU'>Luxembourg</option>
                            <option value='MO'>Macao</option>
                            <option value='MK'>Macedonia</option>
                            <option value='MG'>Madagascar</option>
                            <option value='MW'>Malawi</option>
                            <option value='MV'>Maldives</option>
                            <option value='ML'>Mali</option>
                            <option value='MT'>Malta</option>
                            <option value='MH'>Marshall Islands</option>
                            <option value='MQ'>Martinique</option>
                            <option value='MR'>Mauritania</option>
                            <option value='MU'>Mauritius</option>
                            <option value='YT'>Mayotte</option>
                            <option value='MX'>Mexico</option>
                            <option value='FM'>
                              Micronesia, Federated States of
                            </option>
                            <option value='MD'>Moldova</option>
                            <option value='MC'>Monaco</option>
                            <option value='MN'>Mongolia</option>
                            <option value='MS'>Montserrat</option>
                            <option value='MA'>Morocco</option>
                            <option value='MZ'>Mozambique</option>
                            <option value='MM'>Myanmar</option>
                            <option value='NA'>Namibia</option>
                            <option value='NR'>Nauru</option>
                            <option value='NP'>Nepal</option>
                            <option value='NL'>Netherlands</option>
                            <option value='AN'>Netherlands Antilles</option>
                            <option value='NC'>New Caledonia</option>
                            <option value='NZ'>New Zealand</option>
                            <option value='NI'>Nicaragua</option>
                            <option value='NE'>Niger</option>
                            <option value='NG'>Nigeria</option>
                            <option value='NO'>Norway</option>
                            <option value='OM'>Oman</option>
                            <option value='00'>Others</option>
                            <option value='PK'>Pakistan</option>
                            <option value='PW'>Palau</option>
                            <option value='PS'>Palestinian Territory</option>
                            <option value='PA'>Panama</option>
                            <option value='PG'>Papua New Guinea</option>
                            <option value='PY'>Paraguay</option>
                            <option value='PE'>Peru</option>
                            <option value='PH'>Philippines</option>
                            <option value='PN'>Pitcairn Islands</option>
                            <option value='PL'>Poland</option>
                            <option value='PT'>Portugal</option>
                            <option value='QA'>Qatar</option>
                            <option value='RE'>Reunion</option>
                            <option value='RO'>Romania</option>
                            <option value='RU'>Russia Federation</option>
                            <option value='RW'>Rwanda</option>
                            <option value='SH'>Saint Helena</option>
                            <option value='KN'>Saint Kitts and Nevis</option>
                            <option value='LC'>Saint Lucia</option>
                            <option value='PM'>
                              Saint Pierre and Miquelon
                            </option>
                            <option value='VC'>
                              Saint Vincent and the Grenadines
                            </option>
                            <option value='WS'>Samoa</option>
                            <option value='SM'>San Marino</option>
                            <option value='ST'>Sao Tome and Principe</option>
                            <option value='SA'>Saudi Arabia</option>
                            <option value='SN'>Senegal</option>
                            <option value='CS'>Serbia and Montenegro</option>
                            <option value='SC'>Seychelles</option>
                            <option value='SL'>Sierra Leone</option>
                            <option value='SK'>Slovakia</option>
                            <option value='SI'>Slovenia</option>
                            <option value='SB'>Solomon Islands</option>
                            <option value='SO'>Somalia</option>
                            <option value='ZA'>South Africa</option>
                            <option value='ES'>Spain</option>
                            <option value='LK'>Sri Lanka</option>
                            <option value='SH'>St. Helena</option>
                            <option value='KN'>St. Kitts and Nevis</option>
                            <option value='LC'>St. Lucia</option>
                            <option value='PM'>St. Pierre and Miquelon</option>
                            <option value='SD'>Sudan</option>
                            <option value='SR'>Suriname</option>
                            <option value='SZ'>Swaziland</option>
                            <option value='SE'>Sweden</option>
                            <option value='CH'>Switzerland</option>
                            <option value='SY'>Syria</option>
                            <option value='TW'>Taiwan</option>
                            <option value='TJ'>Tajikistan</option>
                            <option value='TZ'>Tanzania</option>
                            <option value='TH'>Thailand</option>
                            <option value='TL'>Timor-Leste</option>
                            <option value='TG'>Togo</option>
                            <option value='TO'>Tonga</option>
                            <option value='TT'>Trinidad and Tobago</option>
                            <option value='TN'>Tunisia</option>
                            <option value='TR'>Turkey</option>
                            <option value='TM'>Turkmenistan</option>
                            <option value='TC'>Turks and Caicos Islands</option>
                            <option value='TV'>Tuvalu</option>
                            <option value='UG'>Uganda</option>
                            <option value='UA'>Ukraine</option>
                            <option value='AE'>United Arab Emirates</option>
                            <option value='GB'>United Kingdom</option>
                            <option value='US'>United States</option>
                            <option value='UY'>Uruguay</option>
                            <option value='UZ'>Uzbekistan</option>
                            <option value='VU'>Vanuatu</option>
                            <option value='VE'>Venezuela</option>
                            <option value='VN'>Vietnam</option>
                            <option value='WF'>
                              Wallis and Futuna Islands
                            </option>
                            <option value='EH'>Western Sahara</option>
                            <option value='YE'>Yemen</option>
                            <option value='ZR'>Zaire (former)</option>
                            <option value='ZM'>Zambia</option>
                            <option value='ZW'>Zimbabwe</option>
                            <option value='00'>Others</option>
                          </Form.Select>
                        </Col>

                        <Col md={6}>
                          <Form.Label className='label'>
                            IDENTIFICATION TYPE
                          </Form.Label>
                          <Form.Select
                            disabled={!!checkReschedule}
                            id={`identity_type_${i}`}
                            className='field'
                            defaultValue={
                              checkReschedule
                                ? reschedulePassengerDetails[i]
                                    .PassengerNric !== ''
                                  ? 'IC'
                                  : 'PP'
                                : i === 0 && userData != null
                                  ? userData.ic === '' &&
                                    userData.passport === ''
                                    ? 'IC'
                                    : userData.ic !== ''
                                      ? 'IC'
                                      : 'PP'
                                  : 'IC'
                            }
                            onChange={(event) =>
                              handleChangeIdentityType(event, i)
                            }
                          >
                            <option value='IC'>Identity Card</option>
                            <option value='PP'>Passport</option>
                          </Form.Select>
                        </Col>

                        {identityType[i] ? (
                          <>
                            <Col md={6}>
                              <Form.Label className='label'>
                                PASSPORT NUMBER
                              </Form.Label>
                              <Form.Control
                                disabled={!!checkReschedule}
                                id={`passport_${i}`}
                                type='text'
                                className='field'
                                placeholder='e.g. E12345678'
                                onChange={(event) =>
                                  parentPassengerDetailCallback(
                                    event,
                                    event.target.value,
                                    'passport',
                                    i,
                                  )
                                }
                                defaultValue={
                                  checkReschedule
                                    ? reschedulePassengerDetails[i]
                                        .PassengerPassport
                                    : i === 0 && userData != null
                                      ? userData.passport
                                      : ''
                                }
                              />
                            </Col>

                            <Col md={6}>
                              <Form.Label className='label'>
                                PASSPORT EXPIRY (YYYY-MM-DD)
                              </Form.Label>
                              <DatePicker
                                withPortal
                                portalId='datepicker-portal'
                                popperPlacement='bottom-start'
                                onChange={(date) => {
                                  parentPassengerDetailCallback(
                                    date,
                                    changeDateFormatToYYYYMMDD(date),
                                    'passport_expiry_date',
                                    i,
                                  );
                                  setPassportExpiryField(i, date);
                                }}
                                selected={ppexp[i]}
                                // disabled={!!checkReschedule}
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode='select'
                                placeholderText='YYYY-MM-DD'
                                dateFormat='yyyy-MM-dd'
                                className='field datepicker'
                              />
                              {/* <div className="helper">Format: YYYY-MM-DD</div> */}
                            </Col>
                          </>
                        ) : (
                          <Col md={6}>
                            <Form.Label className='label'>ID NUMBER</Form.Label>
                            <Form.Control
                              disabled={!!checkReschedule}
                              id={`ic_${i}`}
                              type='text'
                              maxLength={14}
                              className='field'
                              placeholder='e.g. 900101-01-1234'
                              onChange={(event) =>
                                parentPassengerDetailCallback(
                                  event,
                                  event.target.value,
                                  'ic',
                                  i,
                                )
                              }
                              defaultValue={
                                checkReschedule
                                  ? reschedulePassengerDetails[i].PassengerNric
                                  : i === 0 && userData != null
                                    ? userData.ic
                                    : ''
                              }
                            />
                          </Col>
                        )}
                      </Row>

                      {/* Notice */}
                      {/* <div className="passenger-notice">
												<div className="passenger-notice-title">Important</div>
												<div className="passenger-notice-text">
													Please ensure your <strong>Name</strong>, <strong>IC/Passport</strong>, and{" "}
													<strong>Date of Birth</strong> are entered accurately for ticket issuance and boarding.
												</div>
												<div className="passenger-notice-text mt-2">
													For rides with insurance, all passenger details must be accurate to ensure coverage.
												</div>
											</div> */}
                    </Card.Body>
                  </Card>
                );
              })}
            </section>
          </Form>
        </div>
      </div>
    </>
  );
}

export default PassengerDetails;
